import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { MechanicService } from '../../../business-services/mechanic.service';
import { BrandViewModelMultiSelector, VehicleTypeMultiSelector } from './../../../business-entities/brand-view-model-multiselector';
import { MechanicCompetenceViewModel } from './../../../business-entities/mechanic-competence-view-model';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Component({
  selector: 'app-edit-competence-mechanic',
  templateUrl: './edit-competence-mechanic.component.html',
  styleUrls: ['./edit-competence-mechanic.component.css']
})
export class EditCompetenceMechanicComponent implements OnInit {

  mechanicId: number;
  skillDescription: string = '';
  editform: boolean = false;
  saveButtonEnable = false;

  competenceList: any;
  competenceActiveList: any = [];
  brands: BrandViewModelMultiSelector[];
  brandList: any[] = [];
  vehicleTypes: VehicleTypeMultiSelector[] = [];
  vehicleTypeList: any[] = [];
  efficiency:number = null;
  @ViewChild("addButton") addBtn: ElementRef;

  EditMechanicCompetenceForm: MechanicCompetenceViewModel[] = []

  constructor(
    private service: MechanicService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private toaster: ToastrService,
    private router: Router,
    private activeModal : NgbActiveModal,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.initialize();
  }

  async initialize(): Promise<void> {
    this.spinner.show();
    this.mechanicId = this.service.mechanicId;
    await this.getCompetenceByMechanicId();
    await this.getAllCompetence();
    await this.getAllBrandList();
    await this.GetAllVehicleTypes();
    for (let item of this.competenceList) {
      if (item.isActive) {
        this.competenceActiveList.push(item);
      }
    }

    if (this.editform) {
      this.EditMechanicCompetenceForm.forEach((element,index) => {
        let brand = JSON.parse(JSON.stringify(this.brands));
        brand.forEach(brandItem => {
          if (element.brandId.includes(brandItem.id)) {
            brandItem.checked = true
          }
        });
        let vehicleType = JSON.parse(JSON.stringify(this.vehicleTypes));
        vehicleType.forEach(vehicleTypeItem => {
          if (element.vehicleTypeId.includes(vehicleTypeItem.id)) {
            vehicleTypeItem.checked = true
          }
        });
        this.brandList.push(JSON.parse(JSON.stringify(brand)));
        this.vehicleTypeList.push(JSON.parse(JSON.stringify(vehicleType)));
        this.GetBrandsByCompetence(element.competenceId,index);
      });
    }
    else {
      let mechanicCompetenceViewModel: MechanicCompetenceViewModel = {
        competenceId: null,
        brandId: [],
        vehicleTypeId: []
      };
      this.EditMechanicCompetenceForm.push(mechanicCompetenceViewModel);
      this.vehicleTypeList.push(JSON.parse(JSON.stringify(this.vehicleTypes)));
    }
    this.spinner.hide();
  }

  getCompetenceByMechanicId() {
    this.service.GetMechanicCompetenceByMechanicId(this.mechanicId).then(result => {
      if (result) {
        if (result.responseObject.errorCount) {
          this.editform = false;
        }
        else {
          this.editform = true;
          this.skillDescription = result.responseObject.skillDescription;
          this.efficiency = result.responseObject.efficiency;
          result.responseObject.mechanicCompetence.forEach(element => {
            this.EditMechanicCompetenceForm.push(element);
          });
        }
      }
      this.spinner.hide();
    },
    _error => {
        this.spinner.hide()
      });
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  isPrice(event): void {
    const isDigit = Utility.isDigit(event);
    const isDecimalPoint = Utility.isDecimalPoint(event);
    if (!isDecimalPoint && !isDigit) {
      event.preventDefault();
    }
  }

  async getAllCompetence(): Promise<void> {
    await this.service.getCompetence(0).then(resp => {
      this.competenceList = resp.responseObject;
    })
  }

  async getAllBrandList(): Promise<void> {
    await this.service.getBrand().then(response => {
      if (response) {
        this.brands = response;
        //add All option
        let allBrand: BrandViewModelMultiSelector = {
          id: 0,
          brandCode: 'All',
          brandName: '',
          image: '',
          isActive: true,
          checked: false
        }
        this.brands.unshift(allBrand);
        this.brands.forEach(element => {
          element.checked = false;
        });
      }
    });
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.service.getVehicleTypes().then(data => {
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
      let allVehicleType: VehicleTypeMultiSelector = {
        id: 0,
        name: 'All',
        checked: false,
        isDisplay: true
      }
      this.vehicleTypes.unshift(allVehicleType);
      this.vehicleTypes.forEach(element => {
        element.checked = false;
      });
    });
  }

  competenceNameSelected(_item: any, index: number) {
    this.EditMechanicCompetenceForm[index].brandId = null
    let errorMessage = this.translate.instant("lblCompetenceAlreadySelected");
    this.EditMechanicCompetenceForm.forEach((element, i) => {
      if (i != index) {
        if (element.competenceId === this.EditMechanicCompetenceForm[index].competenceId) {
          this.toaster.error(errorMessage);
          this.cdr.detectChanges();
          this.EditMechanicCompetenceForm[index].competenceId = null;
        }
      }
    });
    if(this.EditMechanicCompetenceForm[index].competenceId != null){
      this.GetBrandsByCompetence(this.EditMechanicCompetenceForm[index].competenceId,index)
    }
  }
 async GetBrandsByCompetence(competenceid:number,index:number){
    await this.service.getBrandsByCompetence(competenceid).then(response => {
      if (response) {
        this.brands = response;
        //add All option
        let allBrand: BrandViewModelMultiSelector = {
          id: 0,
          brandCode: 'All',
          brandName: '',
          image: '',
          isActive: true,
          checked: false
        }
        this.brands.unshift(allBrand);
        this.brands.forEach(element => {
          element.checked = false;
        });

           let brand = JSON.parse(JSON.stringify(this.brands));
           brand.forEach(brandItem => {
             if (this.EditMechanicCompetenceForm[index]?.brandId?.includes(brandItem.id)) {
               brandItem.checked = true
             }
           });
            this.brandList.splice(index,1);
         this.brandList.splice(index,0,JSON.parse(JSON.stringify(brand)));
      }
   });
 }
  shareVehicleTypeCheckedList(item: any) {
    this.EditMechanicCompetenceForm[item.index].vehicleTypeId = [];
    item.checkedList.forEach(element => {
      this.EditMechanicCompetenceForm[item.index].vehicleTypeId.push(element.id);
    });
  }

  shareBrandCheckedList(item: any) {
    this.EditMechanicCompetenceForm[item.index].brandId = [];
    item.checkedList.forEach(element => {
      this.EditMechanicCompetenceForm[item.index].brandId.push(element.id);
    });
  }

  AddMechanicCompetence(_editMechanicCompetence: MechanicCompetenceViewModel, index: number) {
    if (this.EditMechanicCompetenceForm[index].competenceId === null ||
      this.EditMechanicCompetenceForm[index].brandId.length < 1 ||
      this.EditMechanicCompetenceForm[index].vehicleTypeId.length < 1) {
      let errorMessage = this.translate.instant("lblAllFieldsAreMandatory");
      this.toaster.warning(errorMessage);
      return;
    }

    this.brandList.push(JSON.parse(JSON.stringify(this.brands)));
    this.vehicleTypeList.push(JSON.parse(JSON.stringify(this.vehicleTypes)));

    let mechanicCompetenceViewModel: MechanicCompetenceViewModel = {
      competenceId: null,
      brandId: [],
      vehicleTypeId: []
    };
    this.EditMechanicCompetenceForm.push(mechanicCompetenceViewModel);
  }

  RemoveMechanicCompetence(index: number) {
    if (this.EditMechanicCompetenceForm.length > 1) {
      this.EditMechanicCompetenceForm.splice(index, 1);
      this.brandList.splice(index, 1);
      this.vehicleTypeList.splice(index, 1);
    }
  }

  submitForm(isSaveAndClose) {
    if(this.addBtn.nativeElement.disabled)
    {
      let errorMessage = this.translate.instant("lblAllFieldsAreMandatory");
      this.toaster.warning(errorMessage);
      return;
    }
    if(this.efficiency < 1 || this.efficiency > 1000){
      let errorMessage = this.translate.instant("lblEfficiencyShouldBeBetween1to100");
      this.toaster.warning(errorMessage);
      return;
    }
    const mechanicCompetence = {
      mechanicId: this.mechanicId,
      skillDescription: this.skillDescription,
      mechanicCompetence: this.EditMechanicCompetenceForm,
      efficiency:this.efficiency
    }

    let successMessage = this.translate.instant("lblCompetenceAddedSuccessfully");
    let errorMessage = this.translate.instant("lblErrorMessage");
    this.spinner.show();
    this.service.AddEditMechanicCompetence(mechanicCompetence).then(res => {
      this.spinner.hide();
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.toaster.success(successMessage);
        if(isSaveAndClose)
        {
          this.activeModal.close({success : true});
        }
      }
      else if (res.responseCode === Constant.InternalError) {
        let errormsg = this.translate.instant("lblInternalError");
        this.toaster.error(errormsg);
      }
    }, _error => {
      this.spinner.hide();
        this.toaster.error(errorMessage);
    });
  }
  OnClose(){
    this.activeModal.close({ success: true });
  }
}
